import { styled } from 'baseui';

export default styled('div', ({ $theme }) => {
  return {
    padding: '0 0 16px',
    backgroundColor: 'inherit',
    ...$theme.typography.montserrat,
  };
});
